import { Message, MessageInput } from "@hubcapp/graphql";
import { useQuery } from "@apollo/react-hooks";

import message from "../graphql/message.graphql";

const useQueryPollingMessages = (instructorId: string, input: MessageInput) =>
  useQuery<
    { instructor: { messages: Message[] } },
    { instructorId: string; input: MessageInput }
  >(message, {
    variables: { instructorId, input },
  });

export default useQueryPollingMessages;
